/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionPartnerDetailPageItemVo } from './CommissionPartnerDetailPageItemVo';
import {
    CommissionPartnerDetailPageItemVoFromJSON,
    CommissionPartnerDetailPageItemVoFromJSONTyped,
    CommissionPartnerDetailPageItemVoToJSON,
    CommissionPartnerDetailPageItemVoToJSONTyped,
} from './CommissionPartnerDetailPageItemVo';

/**
 * 
 * @export
 * @interface PageDataCommissionPartnerDetailPageItemVo
 */
export interface PageDataCommissionPartnerDetailPageItemVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataCommissionPartnerDetailPageItemVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataCommissionPartnerDetailPageItemVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataCommissionPartnerDetailPageItemVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<CommissionPartnerDetailPageItemVo>}
     * @memberof PageDataCommissionPartnerDetailPageItemVo
     */
    records?: Array<CommissionPartnerDetailPageItemVo>;
}

/**
 * Check if a given object implements the PageDataCommissionPartnerDetailPageItemVo interface.
 */
export function instanceOfPageDataCommissionPartnerDetailPageItemVo(value: object): value is PageDataCommissionPartnerDetailPageItemVo {
    return true;
}

export function PageDataCommissionPartnerDetailPageItemVoFromJSON(json: any): PageDataCommissionPartnerDetailPageItemVo {
    return PageDataCommissionPartnerDetailPageItemVoFromJSONTyped(json, false);
}

export function PageDataCommissionPartnerDetailPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataCommissionPartnerDetailPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CommissionPartnerDetailPageItemVoFromJSON)),
    };
}

export function PageDataCommissionPartnerDetailPageItemVoToJSON(json: any): PageDataCommissionPartnerDetailPageItemVo {
    return PageDataCommissionPartnerDetailPageItemVoToJSONTyped(json, false);
}

export function PageDataCommissionPartnerDetailPageItemVoToJSONTyped(value?: PageDataCommissionPartnerDetailPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CommissionPartnerDetailPageItemVoToJSON)),
    };
}

